import React, { useEffect, useState } from 'react'
import { fechaActual, HoraActual } from '../../../hooks/UseDate'
import {         postDespacharPaquetesFarmaciaQX,  postDespachoQxBodegaFarmacia, postPaqueteNoventaCuatroDespachosQx,    postVerSuministrosDespachosQxFarmacia } from '../../../services/FarmaciaRuta'
import Loading from '../../Loading'
import ModalDescargarPDFSuministrosNoDespachadosQxFarmacia from './ModalDescargarPDFSuministrosNoDespachadosQxFarmacia'

import {PDFDownloadLink,} from '@react-pdf/renderer'
import config from "../../../config";

const ModalConfirmarDespachoQxFarmacia = ({item,setmodalOnClickDespachar,dataEnfermeria,actualizarTablaDespacho}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [loading,setloading]=useState(true)
    const [bodegas,setbodegas]=useState([])
    const [confirmarDespachoParcialODespachoTotal, setconfirmarDespachoParcialODespachoTotal]=useState('')
    const [dataSuministrosDespachados,setdataSuministrosDespachados] = useState([])
    const [dataSuministrosNoDespachados, setdataSuministrosNoDespachados] = useState([])
    //const [suministrosNoDespachados,setsuministrosNoDespachados]=useState('')
    //const [suministrosSiDespachados,setsuministrosSiDespachados]=useState('')
    const [dataSinContrato, setdataSinContrato]=useState([])
    const [errorBodega,seterrorBodega]=useState('Seleccionar Bodega Despacho')
    const [unaBodega,setunaBodega]=useState('')
    const [isDiseableDespachar, setisDiseableDespachar]=useState(false)
    const handleCancelClick=()=>{
        setmodalOnClickDespachar(false)
    }
    

    const handleOnClickDespachosQx=()=>{
      //e.preventDefault();
      //setloading(false)
      setTimeout(() => {   
        console.log('setloading(false)')       
        setloading(false)

        let despachadoParcialoTotal=''
        if(confirmarDespachoParcialODespachoTotal){
          despachadoParcialoTotal='R'
        }else{
          despachadoParcialoTotal='D'
        }
  
        const despacharPaquete={
          //actualizar user
            ProEmpCod: usuarioInfo.Empresa,
            ProMCDpto:usuarioInfo.Sede,
            ProCirCod:item.ProCirCod,
            //ProIndUso:'D',
            ProUsuUso:usuarioInfo.UsuarioEncriptado,
            //consultar consecutivo
            EmpCodA:usuarioInfo.Empresa,
            DocCodA:'TCQ',
            DocNumEsA:'A',
            MCDptoA:usuarioInfo.Sede,
            DocConA:'2',
            //update mas uno consecutivo
            // EmpCodA: res.data[0].EmpCodA,
            // DocCodA: res.data[0].DocCodA,
            // MCDptoA: res.data[0].MCDptoA,
            // DocConA:res.data[0].DocConA,
            // DocNumAcA:`${parseInt(res.data[0].DocNumAcA) + 1}`
            //despachar
           
            
            //ProCirCod: item.ProCirCod,
            PaqCod: item.PaqCod,
            PQCvoDes: "1",
            PQTpoTRN: "DS",
            PQFecHDes: `${fechaActual()} ${HoraActual()}`,          
            PQUsrMov: usuarioInfo.UsuarioEncriptado,
            PQEmpCod: usuarioInfo.Empresa,
            PQCodDoc: "   ",
            PQNumDoc: "0",
            PQSedMov: usuarioInfo.Sede,
            PQPabellon: item.ProCons,
            PqPadCed: dataEnfermeria.idEnfermeria,
            PQBodDes: unaBodega,//e.target.bodegasSelect.value,
            PQSpsNL: "                    ",
            //actualizar estado del suministro
            //ProCirCod:item.ProCirCod,
            //PaqCod:item.PaqCod,
            
            
            PQEdoDes: despachadoParcialoTotal,
            //actualizar procir
            //ProCirCod:item.ProCirCod,
            //ProIndUso:'N',
            
            
            //ProUsuUso:'CUE9F3Q8'
        }
        console.log(despacharPaquete,'despacho antes')
        
          postDespacharPaquetesFarmaciaQX(despacharPaquete).then((res)=>{
            console.log(res.data,'despachadojiji')
            actualizarTablaDespacho(despacharPaquete)
            setmodalOnClickDespachar(false)
            setloading(true)
          })
        
        
        
      }, 500);

     
      
     

    }


    useEffect(()=>{
      setloading(false)
       console.log(item,'data item')
       //console.log(dataEnfermeria,'dataEnfermeria')
       const bodega = {
        EMPCOD: usuarioInfo.Empresa,
        AUsrId: usuarioInfo.usuario,
        BodDspPis: "S",
        MCDpto: usuarioInfo.Sede,
      };

      ///Data para select de farmacia
      postDespachoQxBodegaFarmacia(bodega).then((res)=>{
        console.log(res.data,'bodega')
        setbodegas(res.data)
         //////////////////////////////////data para el PDF ///////////////////////////////
        const despachosPDF={
          ProCirCod: item.ProCirCod,
          PaqCod: item.PaqCod,
          ProEmpCod: usuarioInfo.Empresa,
          ProMCDpto: usuarioInfo.Sede,
          MPCedu: item.MPCedu
        }

        //clinica cartagena
        // const paqueteGenericoCodigo = '39'
            

        //produccion pruebas 
        // const paqueteGenericoCodigo = '94'

        //clinica estancia
        // const paqueteGenericoCodigo = 'GER'

        //variable de entorno
        const paqueteGenericoCodigo = config.PAQUETE_GENERICO_ID
        
        //console.log(item,'item.PaqCod')
        // if(parseInt(item.PaqCod) === parseInt(paqueteGenericoCodigo)){
          if(item.PaqCod.trim() === paqueteGenericoCodigo.trim()){
          postPaqueteNoventaCuatroDespachosQx(despachosPDF).then((res)=>{
            console.log(Object.values(res.data),'paquete 94')
            setTimeout(() => {          
              setloading(true)
            }, 3000);
            if(res.data.contratoPortafolio){

            
            console.log(res,'paquete 94')
            //let dataSuministroPDF= ''
            //let data = res.data.contratoPortafolio

            //data.forEach(itemSuministro=> dataSuministroPDF +=`\n* Para el paquete ${itemSuministro.PaqCod.trim()} con el nombre ${itemSuministro.MSNomG.trim()}, fue desachapo el Suministro ${itemSuministro.MSRESO.trim()} y la Cantidad despachada ${itemSuministro.PQCaSuSl} para el paciente  ${item.MPTDoc.trim()}-${item.MPCedu.trim()} ${item.MPNOMC.trim()}\n `)
            setdataSuministrosDespachados(res.data.contratoPortafolio)
            
            
          }else{
            setdataSinContrato(res.data.contratoSinPortafolio)
          }
          })
        }else{
          postVerSuministrosDespachosQxFarmacia(despachosPDF).then((res)=>{
            // console.log(res.data,'data despachjossss ultimo')
            setTimeout(() => {          
              setloading(true)
            }, 3000);
            if(res.data.contratoPortafolio){
              
              const dataSuministross = res.data.contratoPortafolio
              // console.log(dataSuministross,'dataSuministross')

              //suministros despachados
              const suministrosDespachados = dataSuministross.filter(item=> item.PaqAct === "S")

              //suministros despachos 
              setdataSuministrosDespachados(suministrosDespachados)
              // console.log(suministrosDespachados,'despachados')

              //validar si todos los suministros fueron despachados, si no es entonces queda en el estado despacho parcial
              const estaPaqueteActivo = dataSuministross.some(item=> item.PaqAct === "N")
              setconfirmarDespachoParcialODespachoTotal(estaPaqueteActivo)
              //console.log(estaPaqueteActivo,'estaPaqueteActivo')

              //suministros que fueron despachados
              //console.log(dataSuministross,'suministros SISI despachados')
              // suministrosDespachados.forEach(itemSuministro=> dataSuministroPDF +=`\n* Para el paquete ${itemSuministro.PaqCod.trim()}, fue desachapo el Suministro ${itemSuministro.MSRESO.trim()} y la Cantidad despachada ${itemSuministro.PQCaSuSl} para el paciente  ${item.MPTDoc.trim()}-${item.MPCedu.trim()} ${item.MPNOMC.trim()}\n `)
              // //console.log(dataSuministroPDF,'informe despachados')
              // setsuministrosSiDespachados(dataSuministroPDF)
            
              //suministros no despachados
              
              //let dataSuministrosNOPDF=''
              const suministrosNODespachados = dataSuministross.filter(item=> item.PaqAct === "N")
              setdataSuministrosNoDespachados(suministrosNODespachados)
              //console.log(suministrosNODespachados,'suministros NONO despachados')
              // suministrosNODespachados.forEach(itemSuministro=>dataSuministrosNOPDF += `\n\n* Para el Paquete Qx ${itemSuministro.PaqCod.trim()}, Suministro ${itemSuministro.MSRESO.trim()} del paciente ${item.MPTDoc.trim()}-${item.MPCedu.trim()} ${item.MPNOMC.trim()}, El suministro se encuentra inactivo en el paquete, éste no será despachado.`)
              // //console.log(dataSuministrosNOPDF,'informe no despachados')
              // setsuministrosNoDespachados(dataSuministrosNOPDF)
              
            }else{
              
              setdataSinContrato(res.data.contratoSinPortafolio)
            }
          })
        }
      })
      seterrorBodega('Seleccionar Bodega Despacho')

     
    },[])

    const handleOnchangeBodega=(e)=>{
      //console.log(e.target.value,'select')
      if(e.target.value !== 'Seleccionar Bodega'){
        //console.log('lleno')
        seterrorBodega('')
        setisDiseableDespachar(true)
        setunaBodega(e.target.value)
      }else{
        //console.log('vacio')
        setisDiseableDespachar(false)
        seterrorBodega('Seleccionar Bodega Despacho')
      }
    }
  return (
    <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none pt-6">
          <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Despachar *
              </h5>
              <button
                type="button"
                onClick={handleCancelClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            {loading?
            <form  >
              <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-2/6  ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                     Nombre Paciente
                    </label>
                    <input
                    defaultValue={item.MPNOMC}
                    disabled={true}
                    
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/6  px-1">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      N° Cirugia
                    </label>
                    <input
                      defaultValue={item.ProCirCod}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/6  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                     Paquete
                    </label>
                    <input
                      //onChange={handleOnchange}
                      defaultValue={item.PaqCod}
                      disabled={true}
                      //name='cantidadSuministro'
                      autoComplete='off'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />                    
                  </div>
                  <div className="w-2/6  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                     Nombre Paquete
                    </label>
                    <input
                      //onChange={handleOnchange}
                      defaultValue={item.PaqDes}
                      disabled={true}
                      //name='cantidadSuministro'
                      autoComplete='off'
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />                    
                  </div>
                </div>
              </div>
              <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/3  ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Recibe
                    </label>
                    <input
                    defaultValue={dataEnfermeria.idEnfermeria}
                    disabled={true}
                    
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Recibe Nombre
                    </label>
                    <input
                   //defaultValue={item.MSNomG}
                      defaultValue={dataEnfermeria.nombreEnfermeria}
                      disabled={true}
                      type="text"
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/3  px-1 ">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label inline-block mb-2 text-gray-900 font-medium"
                    >
                      Bodega des.
                    </label>

                    <select
                      //disabled={true}
                      onChange={handleOnchangeBodega}
                      name="bodegasSelect"
                      className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                      aria-label="Default select example"
                    >
                      <option>Seleccionar Bodega</option>
                      {bodegas.map((item) => (
                        <option value={item.BODEGA} key={item.BODEGA}>
                          {item.BODEGA}- {item.BODDESC}
                        </option>
                      ))}
                    </select>
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                      {errorBodega}
                    </label>
                  </div>
                  
                </div>
                
              </div>
           
            
            
            
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
              <button type="button"
              onClick={handleCancelClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal">
              Cancelar
              </button>
              {
                isDiseableDespachar?
                <PDFDownloadLink document={<ModalDescargarPDFSuministrosNoDespachadosQxFarmacia   nombreQuienRecibe={dataEnfermeria.nombreEnfermeria} dataUser={item}  dataSuministrosDespachados={dataSuministrosDespachados} dataSuministrosNoDespachados={dataSuministrosNoDespachados} dataSinContrato={dataSinContrato}/> } fileName="despachoSuministrollll.pdf" >
                <button
                  type="button"
                  onClick={handleOnClickDespachosQx}
                  //disabled={isDiseableDespachar}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Despachar
                </button>
              </PDFDownloadLink>
              :
              <button
                  type="button"
                  //onClick={handleOnClickDespachosQx}
                  //disabled={isDiseableDespachar}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Despachar
                </button>
              }
              
              
            </div>
            </form>
             :
             <div className="text-center py-40">               
                <Loading/>
             </div>
              } 
          </div>
        </div>
      </div>
  )
}


export default ModalConfirmarDespachoQxFarmacia